import clients from '../../../data/clients';

export default {
  slug: 'vr-science-education',
  company: clients.particleDesign.name,
  logo: clients.particleDesign.logo,
  logoWhite: clients.particleDesign.logoWhite,
  blurb: {
    headline: 'How we built a virtual, underwater classroom.',
    tags: [],
    byline: 'Learn more about our work in education',
    background: require('./preview.jpg'),
    backgroundSet: [
      {
        max: 1024,
        src: require('./preview-mobile.jpg'),
      },
    ],
  },
  blocks: [
    {
      module: 'hero',
      background: {
        image: require('./hero.jpg'),
        type: 'image',
      },
      constrain: true,
    },
    {
      module: 'intro',
      title: 'The Classroom of Tomorrow.',
      content: 'Particle Design partnered with a leading HW / SW company whose innovation group is tasked with dreaming up and creating pioneering experiences for new technologies yet to be released to the market.\n\nWith more than 9 years of experience partnering with this innovative company, Particle was poised to help them create an educational experience that would support interesting and engaging interactions that were supported by new 3D depth camera technology.',
      roles: [
        "UX Strategy",
        "Interaction Design",
        "Visual Design",
        "Front-End Development",
        "Back-End Development",
      ],
    },
    {
      module: 'text_image_row',
      images: [
        {
          src: require('./article/1.jpg'),
          height: '490px',
          gravity: 'right center',
          primary: true,
        },
      ],
      content: '## Elevating education through immersive environments.\n\nThe company was looking to design education prototypes that would increase student retention in STEM subjects (science, technology, engineering, and mathematics), with the goal of inspiring collaboration with larger educational SW partners. Most schools currently have tablets for students, but most digital curriculum focus on e-textbooks and videos. Moving beyond this paradigm and harnessing the power of immersive digital experiences meant an opportunity for greater student engagement and thus retention.\n\nWe first tested concept storyboards with middle school and high school science teachers with the goal of building a prototype of the one that showed the most promise. Teachers found the idea of students being able to scan themselves with the 3D camera and insert their avatars into otherwise inaccessible environments, such as space or underwater, most compelling. The Chesapeake Bay Underwater Virtual Curriculum was born.',
    },
    {
      module: 'text_image_row',
      images: [
        {
          src: require('./article/3.jpg'),
          height: '368px',
          gravity: 'left center',
          primary: true,
        },
        {
          src: require('./article/2.jpg'),
          height: '252px',
          gravity: 'left bottom',
          primary: false,
        },
      ],
      content: '## Bringing students a new approach to learning.\n\nOur approach to the design of the prototype was to make the learning experience look and feel like a video game. An RPG aligned with national STEM education standards.\n\nWe built the immersive environment using a 3D game engine and 3D objects. Students could scan themselves and insert their avatar into the environment, walking along the floor of the Bay where they were surrounded by the creatures and plant life of that ecosystem. All organisms were interactive, with info on their unique qualities highlighted. Students could conduct a variety of experiments. They could experience a toxic spill from the perspective of a fish and watch the ecosystem change and die while testing water samples over time to see when life could again thrive in that location. Testing of the prototype with teachers showed that the immersive experience was unique and exciting to educators.\n\nOver the course of six months, Particle worked with our client partner to go from early product ideas, to concept storyboards, through to prototype development, with user feedback integrated all throughout the process.  We were able to succeed in the primary goal: create cutting edge STEM curriculum that capitalized on both emerging technology and the devices students had access to every day in school.',
    },
    {
      module: 'image',
      src: require('./article/4.jpg'),
      alt: 'Image of an apple on top of a stack of books next to a stack of blocks on a table against a white backdrop.',
      visibility: {
        min: 1024,
        max: 10000,
      },
    },
    {
      module: 'relatedWorks',
      works: [
        'hp-wearable',
        'land-rover',
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/content/work/virtual-lesson-plan/index.js